import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const LocationContext = createContext(null);
export const useLocationCtx = () => useContext(LocationContext);

export function LocationProvider({ children }) {
  const { user } = useAuth();
  const [locations, setLocations] = useState([]);
  const [allAccess, setAllAccess] = useState(false);
  const [currentLocationId, setCurrentId] = useState(() => localStorage.getItem('rr_current_loc') || '');

  const loadLocations = useCallback(async () => {
    try {
      const d = await api.request('GET', '/api/admin/my-locations');
      const locs = d.locations || [];
      setLocations(locs); setAllAccess(!!d.allAccess);
      setCurrentId((cur) => {
        if (cur && locs.some((l) => l.id === cur)) return cur;
        const first = locs[0] ? locs[0].id : '';
        if (first) localStorage.setItem('rr_current_loc', first);
        return first;
      });
    } catch (e) { /* not authorized / not logged in */ }
  }, []);

  useEffect(() => { if (user) loadLocations(); }, [user, loadLocations]);

  const setCurrentLocation = (id) => { setCurrentId(id); localStorage.setItem('rr_current_loc', id); };

  return (
    <LocationContext.Provider value={{ locations, allAccess, currentLocationId, setCurrentLocation, reloadLocations: loadLocations }}>
      {children}
    </LocationContext.Provider>
  );
}
